export default __webpack_public_path__ + "static/media/diglog_name.48399e67.png";